import React from 'react';
import UserModal from './user-modal';
import { adminUserRoles, leadRoles, RoleStatus, UserRole } from './utils/enum';
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
// import InputBase from '@mui/material/InputBase';
// import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import MoreIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import { useAppSelector } from '../../redux/hooks';
import { getUserRole } from './utils/auth-service';

// const Search = styled('div')(({ theme }) => ({
//   position: 'relative',
//   borderRadius: theme.shape.borderRadius,
//   backgroundColor: theme.palette.primary.light,
//   // width: '50%',
//   paddingLeft: 0,
//   [theme.breakpoints.up('sm')]: {
//     marginLeft: theme.spacing(1),
//     width: '80%'
//   },
//   [theme.breakpoints.up('md')]: {
//     marginLeft: theme.spacing(1),
//     width: '70%'
//   }
// }));

// const SearchIconWrapper = styled('div')(({ theme }) => ({
//   color: theme.palette.primary.dark,
//   padding: theme.spacing(0, 2),
//   height: '100%',
//   position: 'absolute',
//   pointerEvents: 'none',
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'center'
// }));

const SearchIcons = styled('div')(({ theme }) => ({
  color: theme.palette.grey[700],
  marginLeft: 'auto'
}));

// const StyledInputBase = styled(InputBase)(({ theme }) => ({
//   width: '97%',
//   '.MuiToolbar-root': {
//     paddingLeft: '0',
//     margin: 10
//   },
//   '& .MuiInputBase-input': {
//     color: theme.palette.primary.dark,
//     padding: theme.spacing(1, 1, 1, 0),
//     paddingLeft: `calc(1em + ${theme.spacing(4)})`,
//     transition: theme.transitions.create('width'),
//     [theme.breakpoints.up('md')]: {
//       width: '75%',
//       color: theme.palette.primary.dark
//     }
//   }
// }));

const StyleAppBar = styled(AppBar)(() => ({
  '.MuiToolbar-root': {
    minHeight: '55px',
    paddingLeft: '0'
  }
}));

function getChipColourForRole(role: UserRole): string {
  if (adminUserRoles.includes(role)) {
    return '#0388D180';
  } else if (leadRoles.includes(role)) {
    return '#4bcfe080';
  } else {
    return '#00BF7A80';
  }
}

function getAvatarColourForRole(role: UserRole): string {
  if (adminUserRoles.includes(role)) {
    return '#0388D1';
  } else {
    return '#00BF7A';
  }
}

interface ISearchBarProps<T extends object> {
  data?: T[];
  columnNames?: string[];
  searchBarPlaceholder?: string;
  handleDataChange?: (data: T[]) => void;
  hideTextBox?: boolean;
}

export default function SearchBar<T extends object>({
  data,
  searchBarPlaceholder,
  handleDataChange,
  columnNames,
  hideTextBox = false
}: ISearchBarProps<T>): JSX.Element {
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] =
    React.useState<null | HTMLElement>(null);

  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const handleMobileMenuClose = (): void => {
    setMobileMoreAnchorEl(null);
  };

  const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>): void => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const imageUrl = useAppSelector(
    (state) => state.profileData.profileData?.profilePic
  );

  const name = useAppSelector(
    (state) => state.profileData.profileData?.displayName
  );

  const jobRole = useAppSelector(
    (state) => state.profileData.profileData?.highestRole
  );

  const [userModalOpen, setUserModalOpen] = React.useState(false);
  const handleUserModalOpen = (): void => setUserModalOpen(true);
  const handleUserModalClose = (): void => setUserModalOpen(false);
  const [userRoleLabel, setUserRoleLabel] = React.useState('');
  const userRole = getUserRole(jobRole);

  const renderMobileMenu = (
    <Menu
      sx={{
        display: { xs: 'flex', md: 'none' },
        color: 'primary.dark '
      }}
      anchorEl={mobileMoreAnchorEl}
      open={isMobileMenuOpen}
      onClick={handleMobileMenuClose}
    >
      <MenuItem onClick={handleUserModalOpen}>
        <Avatar
          sx={{
            bgcolor: getAvatarColourForRole(userRole),
            width: '28px',
            height: '28px',
            cursor: 'pointer'
          }}
          src={imageUrl ?? ''}
        />
        <Typography sx={{ margin: '16px' }}>Profile</Typography>
      </MenuItem>
    </Menu>
  );

  React.useEffect(() => {
    if (userRole === UserRole.SuperAdmin) {
      setUserRoleLabel(RoleStatus.SuperAdmin);
    } else if (userRole === UserRole.Admin) {
      setUserRoleLabel(RoleStatus.Admin);
    } else if (userRole === UserRole.ProjectManager) {
      setUserRoleLabel(RoleStatus.ProjectManager);
    } else if (userRole === UserRole.OperationsLead) {
      setUserRoleLabel(RoleStatus.OperationsLead);
    } else {
      setUserRoleLabel(RoleStatus.Member);
    }
  }, [userRole]);

  // const [searchText, setSearchText] = React.useState<string>('');
  // const [searchedData, setSearchedData] = React.useState<T[]>([]);
  // React.useEffect(() => {
  //   if (!hideTextBox) {
  //     let newSearchedData: T[] | undefined;
  //     if (searchText !== '') {
  //       newSearchedData = data?.filter((val) =>
  //         columnNames?.some((columnName) => {
  //           return (
  //             columnName in val &&
  //             typeof val[columnName as keyof T] === 'string' &&
  //             (val[columnName as keyof T] as string)
  //               .toLowerCase()
  //               .includes(searchText.toLowerCase())
  //           );
  //         })
  //       );
  //     } else {
  //       newSearchedData = data;
  //     }
  //     if (
  //       JSON.stringify(newSearchedData) !== JSON.stringify(searchedData) &&
  //       newSearchedData &&
  //       handleDataChange
  //     ) {
  //       handleDataChange(newSearchedData);
  //       setSearchedData(newSearchedData);
  //     }
  //   }
  // }, [searchText, data]);

  return (
    <>
      {userRole && (
        <Box
          data-testid="search-bar"
          sx={{
            flexGrow: 1,
            position: 'relative',
            '.MuiPaper-root': {
              position: 'static',
              boxShadow: 'none'
            }
          }}
        >
          <StyleAppBar>
            <AppBar
              sx={{ backgroundColor: 'background.default', position: 'static' }}
              elevation={0}
            >
              <Toolbar
                sx={{
                  paddingLeft: 0,
                  display: 'flex',
                  alignItems: 'center',
                  position: 'relative'
                }}
              >
                {/* <Search
                  sx={{
                    flexGrow: 0,
                    display: hideTextBox ? 'none' : 'flex',
                    alignItems: 'center'
                  }}
                >
                  <SearchIconWrapper>
                    <SearchIcon id="search-icon" />
                  </SearchIconWrapper>

                  <StyledInputBase
                    id="search-box"
                    placeholder={searchBarPlaceholder}
                    color="primary"
                    inputProps={{
                      'aria-label': 'search'
                    }}
                    value={searchText}
                    onChange={(event) => setSearchText(event.target.value)}
                  />
                </Search> */}

                <Box
                  sx={{
                    display: { xs: 'flex', md: 'none' },
                    color: 'primary.dark ',
                    marginLeft: 'auto'
                  }}
                >
                  <IconButton
                    id="mobile-menu-btn"
                    size="large"
                    aria-label="show more"
                    aria-haspopup="true"
                    onClick={handleMobileMenuOpen}
                    color="primary"
                  >
                    <MoreIcon id="more-icon" />
                  </IconButton>
                </Box>
                <SearchIcons
                  sx={{
                    display: { xs: 'none', md: 'inline-flex' },
                    alignItems: 'center',
                    justifyContent: 'space-between'
                  }}
                >
                  <Chip
                    id="user-role"
                    sx={{
                      backgroundColor: getChipColourForRole(userRole),
                      borderRadius: '8px',
                      marginRight: '30px',
                      fontFamily: 'Be Vietnam Pro',
                      fontWeight: '400',
                      fontSize: '13px',
                      color: '#001E2F'
                    }}
                    label={userRoleLabel}
                  />
                  <Stack direction="row" spacing={2}>
                    <Avatar
                      id={'avatar'}
                      sx={{
                        bgcolor: getAvatarColourForRole(userRole),
                        width: '28px',
                        height: '28px',
                        cursor: 'pointer'
                      }}
                      onClick={handleUserModalOpen}
                      src={imageUrl ?? ''}
                      alt={name}
                    >
                      {name?.charAt(0)}
                    </Avatar>
                  </Stack>
                </SearchIcons>
              </Toolbar>
            </AppBar>
          </StyleAppBar>
          {renderMobileMenu}
          <UserModal open={userModalOpen} handleClose={handleUserModalClose} />
        </Box>
      )}
    </>
  );
}
